import React from 'react';
import { EquipmentAttachmentType } from '../../../model/equipment-attachment-type';
import { entityManagerProvider } from '../../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
interface EquipmentAttachmentTypeList {
  equipmentAttachmentType: EquipmentAttachmentType[];
  selected: EquipmentAttachmentType;
  ids: number;
  loading: boolean;
  allowAdd: boolean;
}

class EquipmentAttachmentTypes extends React.Component<
  any,
  EquipmentAttachmentTypeList
> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      equipmentAttachmentType: [] as EquipmentAttachmentType[],
      selected: null as EquipmentAttachmentType,
      ids: 0 as number,
      loading: true,
      allowAdd: true,
    };
    this.manager = entityManagerProvider.newManager();

    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addEquipmentAttachmentType = this.addEquipmentAttachmentType.bind(
      this
    );
    this.remove = this.remove.bind(this);
    this.setTypeState = this.setTypeState.bind(this);
  }

  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('EquipmentAttachmentTypes');
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        equipmentAttachmentType: qr.results,
        loading: false,
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }

  addEquipmentAttachmentType() {
    this.setState({
      ids: this.state.ids - 1,
      allowAdd: false,
    });
    let equipmentAttachmentType = this.manager.createEntity(
      EquipmentAttachmentType.prototype.entityType,
      {
        equipmentAttachmentTypeId: this.state.ids,
      }
    ) as EquipmentAttachmentType;
    // select the new customer, and add it to the list of customers
    this.setState({
      selected: equipmentAttachmentType,
      equipmentAttachmentType: this.state.equipmentAttachmentType.concat([
        equipmentAttachmentType,
      ]),
    });
  }

  remove(ent: EquipmentAttachmentType) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then(() => {
        // refresh customer list to remove deleted customers
        this.setState({
          selected: null,
          equipmentAttachmentType: this.manager.getEntities(
            'EquipmentAttachmentType'
          ) as EquipmentAttachmentType[],
        });
      })
      .catch((error) => {
        this.setState({
          selected: null,
          equipmentAttachmentType: this.manager.getEntities(
            'EquipmentAttachmentType'
          ) as EquipmentAttachmentType[],
        });
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        this.setState({
          loading: false,
          selected: null,
          allowAdd: true,
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
    let types = this.manager.getEntities(
      'EquipmentAttachmentType'
    ) as EquipmentAttachmentType[];
    types = types.sort(
      (a, b) => a.equipmentAttachmentTypeId - b.equipmentAttachmentTypeId
    );
    this.setState({
      selected: null,
      equipmentAttachmentType: types,
      allowAdd: true,
    });
  }

  renderPaymentEdit() {
    let equipmentAttachmentType = this.state.selected;
    if (equipmentAttachmentType) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, equipmentAttachmentType)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <form>
                <div className="form-group row">
                  <div className="col-lg-12">
                    <label>Type Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="attTypeName"
                      value={equipmentAttachmentType.attTypeName || ''}
                      onChange={equipmentAttachmentType.handleChange}
                    />
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  setTypeState(type: EquipmentAttachmentType) {
    this.rejectChanges();
    this.setState({ selected: type });
  }
  render() {
    return (
      <div className="card card-custom card-stretch">
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              Attachment Types
            </h3>
            <span className="text-muted font-weight-bold font-size-sm mt-1">
              e.g. Custom, Invoice, Bill of Lading ...
            </span>
          </div>
          <div className="card-toolbar">
            <button
              type="submit"
              className="btn btn-success mr-2"
              onClick={this.addEquipmentAttachmentType}
              disabled={!this.state.allowAdd}
            >
              Add EquipmentAttachmentType
            </button>
            <button
              type="submit"
              className="btn btn-warning mr-2"
              onClick={() => {
                this.setState({ selected: null, allowAdd: true });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="card-body">
          {this.state.loading ? (
            <div className="row" style={{ minHeight: '200px' }}>
              <Loader
                size="large"
                style={{ position: 'relative', margin: '60px auto' }}
                type="converging-spinner"
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-xl-6">
                <div style={{ overflow: 'scroll', height: '300px' }}>
                  <Table className="table" bordered>
                    <thead>
                      <tr>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.equipmentAttachmentType?.map((type, idx) => {
                        return (
                          <tr
                            key={type.equipmentAttachmentTypeId}
                            style={{
                              backgroundColor:
                                type === this.state.selected
                                  ? 'lightgray'
                                  : 'white',
                            }}
                            onClick={() => this.setTypeState(type)}
                          >
                            <td>{type.attTypeName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="col-xl-6">{this.renderPaymentEdit()}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EquipmentAttachmentTypes;
